import axios from "axios";
import { API_END_POINT } from "../../../constants/api";

export function addDispatch(dispatchData) {
  let authToken = localStorage.getItem("usertoken");
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  const body = JSON.stringify(dispatchData);
  let response = axios.post(
    `${API_END_POINT}/contract/dispatch/add/${dispatchData.contractId}`,
    body,
    config
  );

  return response;
}

export function getDispatchesOfContract(params) {
  let authToken = localStorage.getItem("usertoken");
  let { contractId, limit } = params;

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  let response = axios.get(
    `${API_END_POINT}/contract/dispatch/get/${contractId}/limit=${limit}`,

    config
  );

  return response;
}

export function addClothReturn(params) {
  let authToken = localStorage.getItem("usertoken");
  let { contractId, dispatchId, clothReturnPayload } = params;

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };

  const body = JSON.stringify(clothReturnPayload);
  let response = axios.put(
    `${API_END_POINT}/contract/dispatch/add-clothReturn/${contractId}/${dispatchId}`,
    body,
    config
  );

  return response;
}

export function updateDispatch(params) {
  let authToken = localStorage.getItem("usertoken");
  let { contractId, dispatchIdToEdit, updatedValue } = params;

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };

  const body = JSON.stringify(updatedValue);
  let response = axios.put(
    `${API_END_POINT}/contract/dispatch/edit/${contractId}/${dispatchIdToEdit}`,
    body,
    config
  );

  return response;
}

export function getCompanyDispatches(companyId, limit = 500) {
  let authToken = localStorage.getItem("usertoken");
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  return axios.get(
    `${API_END_POINT}/contract/dispatch/company/${companyId}/limit=${limit}`,
    config
  );
}

export function getCompanyClothReturns(companyId, limit = 500) {
  let authToken = localStorage.getItem("usertoken");
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  return axios.get(
    `${API_END_POINT}/contract/dispatch/cloth-return/company/${companyId}/limit=${limit}`,
    config
  );
}

export function deleteDispatch(dispatchId, companyId) {
  let authToken = localStorage.getItem("usertoken");
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  return axios.delete(
    `${API_END_POINT}/contract/dispatch/delete/${dispatchId}/${companyId}`,
    config
  );
}
